import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
export const HostSalon = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    aboutYou: '',
    inspiration: '',
    attendees: '',
    existingCommunity: '',
    communityDescription: '',
    promotionPlan: '',
    experience: '',
    eventDescription: '',
    engagementPlan: '',
    orientationAvailability: '',
    documentationWillingness: '',
    agreement: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xnngonyv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          aboutYou: '',
          inspiration: '',
          attendees: '',
          existingCommunity: '',
          communityDescription: '',
          promotionPlan: '',
          experience: '',
          eventDescription: '',
          engagementPlan: '',
          orientationAvailability: '',
          documentationWillingness: '',
          agreement: ''
        });
        setIsSubmitted(true);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3119">
        <div className="container mx-auto px-4 py-16" data-id="element-3120">
          <div className="max-w-3xl mx-auto" data-id="element-3121">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-300 text-center" data-id="element-3122">
              <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-3123">
                Thank you for applying to host a Networking Salon!
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3124">
                Your submission has been received, and our team will review it
                carefully. If selected, you'll receive hosting guidelines,
                support resources, and a short orientation session to help you
                plan your event.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3125">
                Together, we'll keep building spaces where connections turn into
                real opportunities.
              </p>
              <a href="https://wa.link/nc2jpo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-3126">
                <span className="mr-2" data-id="element-3127">💬</span>
                Chat With Us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white min-h-screen" data-id="element-3128">
      <section className="relative py-16 border-b border-gray-200" data-id="element-3129">
        <div className="absolute inset-0 z-0" data-id="element-3130">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="Host a Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3131" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3132"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3133">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3134">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3135">
              Host a Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3136">
              Create meaningful connections in your community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-3137">
        <div className="container mx-auto px-4" data-id="element-3138">
          <div className="max-w-3xl mx-auto" data-id="element-3139">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-3140">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-3141">
                Host a Networking Salon — Application Form
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3142">
                We're excited that you'd like to host a Networking Salon!
                Hosting is more than putting people in a room — it's about
                curating meaningful conversations, creating safe spaces for
                connection, and upholding the values of The Networking Salon.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3143">
                This short form helps us understand your readiness, your
                audience, and how you plan to make your salon special.
              </p>
              {error && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md mb-6" data-id="element-3144">
                  {error}
                </div>}
              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-3145">
                <div className="space-y-6" data-id="element-3146">
                  <div data-id="element-3147">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3148">
                      Section 1: Host Information
                    </h3>
                    <div className="space-y-4" data-id="element-3149">
                      <div data-id="element-3150">
                        <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-3151">
                          Full Name <span className="text-gray-500" data-id="element-3152">*</span>
                        </label>
                        <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3153" />
                      </div>
                      <div data-id="element-3154">
                        <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-3155">
                          Email Address <span className="text-gray-500" data-id="element-3156">*</span>
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3157" />
                      </div>
                      <div data-id="element-3158">
                        <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-3159">
                          Phone Number (WhatsApp Preferred){' '}
                          <span className="text-gray-500" data-id="element-3160">*</span>
                        </label>
                        <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3161" />
                      </div>
                      <div data-id="element-3162">
                        <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-3163">
                          City, Country <span className="text-gray-500" data-id="element-3164">*</span>
                        </label>
                        <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3165" />
                      </div>
                      <div data-id="element-3166">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3167">
                          What best describes you?{' '}
                          <span className="text-gray-500" data-id="element-3168">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3169">
                          {['Community Builder', 'Event Organizer', 'Business Owner / Founder', 'Professional / Creative', 'Student / Young Leader', 'Other'].map(option => <div key={option} className="flex items-center" data-id="element-3170">
                              <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3171" />
                              <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-3172">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-3173">
                        <label htmlFor="aboutYou" className="block text-gray-700 font-medium mb-1" data-id="element-3174">
                          Tell us a bit about yourself{' '}
                          <span className="text-gray-500" data-id="element-3175">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3176">
                            Include your background, what you do, and what
                            drives your interest in community building.
                          </span>
                        </label>
                        <textarea id="aboutYou" name="aboutYou" value={formData.aboutYou} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3177" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3178">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3179">
                      Section 2: Event Vision & Reach
                    </h3>
                    <div className="space-y-4" data-id="element-3180">
                      <div data-id="element-3181">
                        <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-3182">
                          What inspired you to host a Networking Salon?{' '}
                          <span className="text-gray-500" data-id="element-3183">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3184">
                            We want to understand your motivation — what excites
                            you about this platform?
                          </span>
                        </label>
                        <textarea id="inspiration" name="inspiration" value={formData.inspiration} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3185" />
                      </div>
                      <div data-id="element-3186">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3187">
                          Estimated Number of Attendees{' '}
                          <span className="text-gray-500" data-id="element-3188">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3189">
                          {['20–50', '51–100', '101–200', 'More than 200'].map(option => <div key={option} className="flex items-center" data-id="element-3190">
                                <input type="radio" id={`attendees-${option}`} name="attendees" value={option} checked={formData.attendees === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3191" />
                                <label htmlFor={`attendees-${option}`} className="text-gray-700" data-id="element-3192">
                                  {option}
                                </label>
                              </div>)}
                        </div>
                      </div>
                      <div data-id="element-3193">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3194">
                          Do you have an existing community or audience you can
                          invite? <span className="text-gray-500" data-id="element-3195">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3196">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-3197">
                              <input type="radio" id={`existingCommunity-${option}`} name="existingCommunity" value={option} checked={formData.existingCommunity === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3198" />
                              <label htmlFor={`existingCommunity-${option}`} className="text-gray-700" data-id="element-3199">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.existingCommunity === 'Yes' && <div data-id="element-3200">
                          <label htmlFor="communityDescription" className="block text-gray-700 font-medium mb-1" data-id="element-3201">
                            If yes, please describe your community or network
                            <span className="block text-sm text-gray-500" data-id="element-3202">
                              Who are they? What connects them? How do you
                              normally engage with them?
                            </span>
                          </label>
                          <textarea id="communityDescription" name="communityDescription" value={formData.communityDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3203" />
                        </div>}
                      <div data-id="element-3204">
                        <label htmlFor="promotionPlan" className="block text-gray-700 font-medium mb-1" data-id="element-3205">
                          How will you promote the event to ensure attendance?{' '}
                          <span className="text-gray-500" data-id="element-3206">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3207">
                            Share your plan — social media, word of mouth,
                            partnerships, campus networks, etc.
                          </span>
                        </label>
                        <textarea id="promotionPlan" name="promotionPlan" value={formData.promotionPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3208" />
                      </div>
                      <div data-id="element-3209">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3210">
                          Do you have experience organizing or co-hosting
                          events? <span className="text-gray-500" data-id="element-3211">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3212">
                          {["Yes, I've organized events before", "Not yet, but I'm confident I can handle it"].map(option => <div key={option} className="flex items-center" data-id="element-3213">
                              <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3214" />
                              <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-3215">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.experience === "Yes, I've organized events before" && <div data-id="element-3216">
                          <label htmlFor="eventDescription" className="block text-gray-700 font-medium mb-1" data-id="element-3217">
                            If yes, briefly describe one event you've hosted or
                            contributed to
                          </label>
                          <textarea id="eventDescription" name="eventDescription" value={formData.eventDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3218" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-3219">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3220">
                      Section 3: Alignment & Commitment
                    </h3>
                    <div className="space-y-4" data-id="element-3221">
                      <div data-id="element-3222">
                        <label htmlFor="engagementPlan" className="block text-gray-700 font-medium mb-1" data-id="element-3223">
                          The Networking Salon is about meaningful connection,
                          not just attendance. How will you ensure your guests
                          engage deeply and not just "show up"?{' '}
                          <span className="text-gray-500" data-id="element-3224">*</span>
                        </label>
                        <textarea id="engagementPlan" name="engagementPlan" value={formData.engagementPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3225" />
                      </div>
                      <div data-id="element-3226">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3227">
                          Will you be available for a short orientation session
                          before hosting?{' '}
                          <span className="text-gray-500" data-id="element-3228">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3229">
                          {['Yes, absolutely', "I'll need advance notice", 'Maybe, depending on timing'].map(option => <div key={option} className="flex items-center" data-id="element-3230">
                              <input type="radio" id={`orientationAvailability-${option}`} name="orientationAvailability" value={option} checked={formData.orientationAvailability === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3231" />
                              <label htmlFor={`orientationAvailability-${option}`} className="text-gray-700" data-id="element-3232">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-3233">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3234">
                          Are you willing to document your salon (photos, short
                          recap, highlights) and share them with our team for
                          visibility? <span className="text-gray-500" data-id="element-3235">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3236">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-3237">
                              <input type="radio" id={`documentationWillingness-${option}`} name="documentationWillingness" value={option} checked={formData.documentationWillingness === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3238" />
                              <label htmlFor={`documentationWillingness-${option}`} className="text-gray-700" data-id="element-3239">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3240">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3241">
                      Final Declaration
                    </h3>
                    <div data-id="element-3242">
                      <label className="block text-gray-700 font-medium mb-1" data-id="element-3243">
                        I understand that hosting a Networking Salon means
                        representing the brand's values of collaboration,
                        respect, and authenticity.{' '}
                        <span className="text-gray-500" data-id="element-3244">*</span>
                      </label>
                      <div className="space-y-2" data-id="element-3245">
                        {['Yes, I understand and agree', "I'd like to learn more first"].map(option => <div key={option} className="flex items-center" data-id="element-3246">
                            <input type="radio" id={`agreement-${option}`} name="agreement" value={option} checked={formData.agreement === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3247" />
                            <label htmlFor={`agreement-${option}`} className="text-gray-700" data-id="element-3248">
                              {option}
                            </label>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2" data-id="element-3249">
                  <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-3250">
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>;
};